import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background-image: url("img/assessments-decoration.svg");
  background-repeat: no-repeat;
  background-size: min(15vw, 120px);
  padding: 2em;
  margin-top: 3em;
`;

export const Photo = styled.img`
  min-width: 105px;
  max-width: 300px;
  width: 100%;
`;

export const Content = styled.div`
  max-width: 434px;
  flex: 1;
`;

export const Title = styled.h2`
  font-size: 36px;
  font-weight: normal;
  margin: 1em 0 0;

  span {
    font-size: 48px;
    display: block;
  }
`;

export const Description = styled.p`
  color: #888888;
  line-height: 200%;
  font-size: 14px;
  margin: 2em 0;
`;
